import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-footer-end',
  template: '<ng-content />',
  styleUrls: ['./footer-end.component.scss']
})

export class FooterEndComponent {
}
